import achievementSection from './achievementSection';
import referralReducer from '~referral/stores';
import baseReduxStore from './storeBase';
import linkedinPostShare from '~referral/stores/linkedinPostShare';
import stats from '~profile_stats/stores';

const reducers = {
  stats,
  achievementSection,
  referral: referralReducer,
  linkedinPostShare,
};

export default baseReduxStore(reducers);
